import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Field, Form, Formik} from "formik";
import Loader from "../../loaders/Loader";
import {USER_PROJECT, USER_ROLE} from "../../../constants/Auth";
import {logOut} from "../../../redux/dataUploader/dataSlice";

import "react-tagsinput/react-tagsinput.css";
import './add-item.scss'
import '../../forms/UpdateConfigForm/update-config-form.scss'

const CreateBlogPopup = ({
                            setInitialValues,
                            closePopup,
                            isPopupType,
                            setBlogsList,
                            projectsList,
                            usersList,
                            manageCompaniesIdList,
                            setConfirmationMessage,
                            setConfirmationMessageText,
                            selectedUser
                      }) => {
    const dispatch = useDispatch();
    const [initialValues] = useState({
        domain: '',
        manage_companies_id: '',
        short_name: '',
        user_id: usersList
    });

    const userId = localStorage.getItem('id');
    const projectName = localStorage.getItem(USER_PROJECT);
    const role = localStorage.getItem(USER_ROLE);
    const currentItemData = useSelector((state) => state.dataUploader.voluumAlertItem);
    const [fieldsError, setFieldsError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [formError, setFormError] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("auth_token");

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    useEffect(() => {
        setIsLoading(true)
        const currentItemDataLength = Object.keys(currentItemData).length;
        if (currentItemDataLength) {
            setInitialValues(currentItemData);
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }, [currentItemData, setInitialValues])

    const validateOther = value => {
        const regex = /^[a-zA-Z0-9 !@#$%^&*()_+\-='"\\|,.?]*$/
        if (value === '') {
            return 'Required field';
        } else if (!regex.test(value)) {
            return 'No special symbols';
        }
    }

    const validateDomain = (value) => {
        if (!value || value.trim() === '') {
            return 'Required field';
        }

        const trimmed = value.trim();

        if (/^https?:\/\//i.test(trimmed)) {
            return 'Do not include http:// or https://';
        }
        // if (/^www\./i.test(trimmed)) {
        //     return 'Do not include www.';
        // }

        const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

        if (!domainRegex.test(trimmed)) {
            return 'Enter valid domain (e.g. example.com)';
        }

        // return undefined;
    };

    const onSubmit = async (values) => {
        console.log(values);
        try {
            setFieldsError(false);
            setFormLoading(true);
            setErrorMessages([]);
            
            const formData = new FormData();
            if(values.domain) formData.append('domain', values.domain);
            if(values.manage_companies_id) formData.append('manage_companies_id', values.manage_companies_id);
            if(values.short_name) formData.append('short_name', values.short_name);
            if(values.user_id !== '') formData.append('user_id', values.user_id);

            // form data formation
            const res = await fetch(`${localStorage.getItem('apiUrl')}api/blogs/store?per_page=1000`, {
                method: 'POST',
                headers: { 
                    "Authorization": `Bearer ${token}` 
                },
                body: formData
            });
        //     // api call
            checkSession(res.status);

            const data = await res.json();
            
            if(data.status === 'success') {
                setBlogsList(data?.blogs?.data || []);
                closePopup();
                setConfirmationMessage(true);
                setConfirmationMessageText(`Blog ${values.domain} successfully created`);
            } else {
                const errors = Object.values(data.errors).flat().map(String).map(s => s.trim()).filter(Boolean);
                setFieldsError(true);
                setErrorMessages(errors);
            }
        } catch (error) {
            console.error("Server connection error:", error);
            setFieldsError(true);
        } finally {
            setFormLoading(false);
        }
    }

    return (
        <div className='add-item-popup-container'>
            <div className="add-item-popup-block">
                <div className='form-wrap'>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        onSubmit={onSubmit}>
                        {({errors, touched}) => (
                            <Form>
                                <div className="title-wrap">
                                    <h1>
                                        Create new Blog
                                    </h1>
                                    <div className="close-btn" onClick={() => closePopup(false)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/close-btn.svg`} alt="close popup"/>
                                    </div>
                                </div>
                                {
                                    isLoading ?
                                        <Loader/>
                                        :
                                        <>
                                            <div className="form-flex-container">
                                                {Object.keys(initialValues).map(inputItem => {
                                                    
                                                    // if(role !== 'admin' && (inputItem === 'user_id')) return null;
                                                    
                                                    if (inputItem === 'domain') {
                                                        return (
                                                            <div className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                 key={inputItem}>
                                                                <label htmlFor={inputItem}>{inputItem.replace(/[_\-\s]+/g, ' ')}</label>
                                                                <Field
                                                                    id={inputItem}
                                                                    name={inputItem}
                                                                    validate={validateDomain}
                                                                />
                                                                {errors[inputItem] && touched[inputItem] ? <div
                                                                    className='form-error'>{errors[inputItem]}</div> : null}
                                                            </div>
                                                        )
                                                    }

                                                    if ( inputItem === 'manage_companies_id') {
                                                        return (
                                                            <div
                                                                className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                key={inputItem}>
                                                                <label htmlFor={inputItem}
                                                                        className="toggle-label">Company name</label>
                                                                <Field as="select" name={inputItem}>
                                                                    <option key={inputItem}
                                                                                    value='def'>Chose Company name</option>
                                                                    {Object.entries(manageCompaniesIdList)
                                                                    .sort((a, b) => String(a[1]).localeCompare(String(b[1]), undefined, { sensitivity: "base" }))
                                                                    .map(([id, name]) => (
                                                                        <option key={id} value={id}>
                                                                            {name}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        )
                                                    }

                                                    if (inputItem === 'user_id') {
                                                        const currentUser = {
                                                            [selectedUser.id]: selectedUser.name
                                                        }
                                                        return (
                                                            <div
                                                                className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                key={inputItem}>
                                                                <label htmlFor={inputItem}
                                                                        className="toggle-label">User Name</label>
                                                                <Field as="select" name={inputItem}>
                                                                    <option key={inputItem}
                                                                                    value='def'>Chose User name</option>
                                                                    {Object.entries(currentUser)
                                                                        .sort((a, b) => String(a[1]).localeCompare(String(b[1]), undefined, { sensitivity: "base" }))
                                                                        .map(([id, name]) => (
                                                                            <option key={id} value={id}>
                                                                                {name}
                                                                            </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        )
                                                    } 

                                                    // if (inputItem === 'project_id') {
                                                    //     return (
                                                    //         <div
                                                    //             className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                    //             key={inputItem}>
                                                    //             <label htmlFor={inputItem}
                                                    //                     className="toggle-label">Project</label>
                                                    //             <Field as="select" 
                                                    //                 name={inputItem}
                                                    //                 validate={validateOther}
                                                    //                 >
                                                    //                 <option value=''>Choose Project Name</option>
                                                    //                 {projectsList.map((option) => {
                                                    //                     return (
                                                    //                         <option key={option.id}
                                                    //                                 value={option.id}>{option.name}</option>
                                                    //                     )
                                                    //                 })}
                                                    //             </Field>
                                                    //             {errors[inputItem] && touched[inputItem] ? <div
                                                    //                 className='form-error'>{errors[inputItem]}</div> : null}
                                                    //         </div>
                                                    //     )
                                                    // }

                                                    return (
                                                        <div className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                             key={inputItem}>
                                                            <label htmlFor={inputItem}>{inputItem.replace(/[_\-\s]+/g, ' ')}</label>
                                                            <Field
                                                                id={inputItem}
                                                                name={inputItem}
                                                                type='text'
                                                            />
                                                            {errors[inputItem] && touched[inputItem] ? <div
                                                                className='form-error'>{errors[inputItem]}</div> : null}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div className="config-btns-block">
                                                <div className="discard-btn" onClick={() => closePopup(false)}>Discard</div>
                                                <button className='update-btn'
                                                    type="submit">Create</button>
                                            </div>
                                        </>
                                }
                            </Form>
                        )}
                    </Formik>
                    {formLoading ? <div className="config-btns-loader-block"><Loader/></div> : null}
                    {fieldsError ?
                        <div className="config-btns-message-block">
                            {errorMessages.map((item, index) => {
                                return <p key={item[index]} className='new-user-error'>{item}</p>
                            })}
                        </div> : ''}
                    {formError ?
                        <div className="config-btns-message-block"><p className='new-user-error'>Some error occurred</p>
                        </div> : ''}
                    {formSuccess ? <div className="config-btns-message-block"><p className='new-user-success'>Account
                        is {isPopupType === 'updating' ? 'updated' : 'created'}</p></div> : ''}
                </div>
            </div>
        </div>
    )
}

export default CreateBlogPopup;